export default {
    Notes: 'الإشعار|الإشعارات',
};
